import axios from 'axios'

import { SERVER, REACT_APP_API_TOKEN } from '../../settings'

axios.interceptors.response.use(
  response => response,
  error => Promise.reject(error),
)

const authHeaders = () => ({
  Authorization: `Bearer ${REACT_APP_API_TOKEN}`,
})

const cmsUrl = (endpoint: string) => {
  if (!SERVER) {
    throw new Error(
      'REACT_APP_SERVER is not set. Copy apps/devices/.env.example to apps/devices/.env (or root .env) and set the Strapi URL, token, and NAV_ID.',
    )
  }
  return SERVER + endpoint
}

export const get = (endpoint: string, params?: Record<string, unknown>) =>
  axios({
    url: cmsUrl(endpoint),
    method: 'get',
    headers: authHeaders(),
    params,
  })

export const post = (endpoint: string, data?: unknown) =>
  axios({
    url: cmsUrl(endpoint),
    method: 'post',
    headers: authHeaders(),
    responseType: 'json',
    data,
  })

export const patch = (endpoint: string, data?: unknown) =>
  axios({
    url: cmsUrl(endpoint),
    method: 'patch',
    headers: authHeaders(),
    responseType: 'json',
    data,
  })

export const remove = (endpoint: string, data?: unknown) =>
  axios({
    url: cmsUrl(endpoint),
    method: 'delete',
    headers: authHeaders(),
    responseType: 'json',
    data,
  })

export type ApiRequestParams = Record<string, unknown>
